import React from 'react';
import { Eye, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProfileViewsCard = ({ views = [], count = 0, days = 7 }) => {
  const navigate = useNavigate();

  const handleViewProfile = (publicLinkId) => {
    if (publicLinkId) {
      navigate(`/profile/public/${publicLinkId}?source=profile_views`);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
          <Eye className="w-5 h-5 text-primary-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">Profile Views</h3>
          <p className="text-sm text-gray-600">Last {days} days</p>
        </div>
        <div className="text-3xl font-bold text-primary-600">{count}</div>
      </div>

      {views.length > 0 ? (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {views.slice(0, 10).map((view, index) => {
            const photoUrl =
              view.viewerPhotoUrl ||
              view.viewer_photo_url ||
              view.viewerPhoto ||
              view.photo_url ||
              '';
            return (
              <div
                key={view.eventId || index}
                className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer"
                onClick={() => handleViewProfile(view.viewerPublicLinkId)}
              >
                {photoUrl ? (
                  <img
                    src={photoUrl}
                    alt=""
                    className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                    <User className="w-4 h-4 text-gray-600" />
                  </div>
                )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {view.viewerName || 'Anonymous'}
                </p>
                {view.viewerCompany && (
                  <p className="text-xs text-gray-500 truncate">{view.viewerCompany}</p>
                )}
              </div>
              <span className="text-xs text-gray-400">
                {new Date(view.timestamp).toLocaleDateString()}
              </span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 text-sm">
          No profile views in the last {days} days
        </div>
      )}
    </div>
  );
};

export default ProfileViewsCard;
